import { TagsInput as GigTagsInput, TagsInputProps, AutocompleteItem } from '@gloat/gig';
import { useTranslate, i18nKeys } from '@gloat/glocalize';
import { apiAuthClient } from '../../root/api-auth-client';

export const TagsInput = <T = AutocompleteItem,>(props: Omit<TagsInputProps<T>, 'apiAuthClient'>) => {
  const translate = useTranslate();

  return (
    <GigTagsInput<T>
      maxAllowedMessageText={translate({
        id: i18nKeys.PROFILE_STRENGTH_BOOST_COUNTER,
        data: { number: props.values?.length || 0, total: props.maxAllowed },
      })}
      {...props}
      apiAuthClient={apiAuthClient}
    />
  );
};
